
const FIELD_EMAIL_NAME = 'name';

const FIELD_EMAIL_NAME_MAX_LENGTH = 150;

const FIELD_FROM_NAME = 'fromName';

const FIELD_FROM_EMAIL_USERNAME = 'fromEmail';

const FIELD_REPLY_TO_NAME = 'replyToName';

const FIELD_REPLY_TO_EMAIL_DOMAIN = 'selectedReplyToDomainName';

const FIELD_REPLY_TO_EMAIL_USERNAME = 'replyToEmail';

const FIELD_SUBJECT_LINE = 'subject';

const FIELD_SUBJECT_LINE_MAX_LENGTH = 150;

const FIELD_PREVIEW_TEXT = 'previewText';

const FIELD_PREVIEW_TEXT_MAX_LENGTH = 150;

const SEND_TEST_EMAIL = 'testEmails';

const SCHEDULE_DATE = 'scheduleDate';

const SCHEDULE_DATE_HOUR = 'scheduleHour';

const SCHEDULE_DATE_MINUTES = 'scheduleMinutes';

const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address. Perhaps you missed a "." or "@" somewhere?';

const REQUIRED_EMAIL_MESSAGE = 'Please enter an email address.';

const INVALID_NAME_MESSAGE = 'Please enter a name.';

const MISSING_TEMPLATE_ID_MESSAGE = 'Please Choose a template to continue';

const SELECTED_TIME_BEFORE_NOW = 'To schedule this email, you must select a date and time in the future.';

const INVALID_EMAIL_FROM_NAME = 'Please enter a valid from name.';

const INVALID_EMAIL_USERNAME = 'Please enter a valid email username.';

const INVALID_EMAIL_REPLY_TO_NAME = 'Please enter a valid reply to name.';

//these special characters are used to check whether an email username is valid or not
const INVALID_SPECIAL_CHARACTERS = ["@",",",";",":","!","(",")","[","]","<",">",".."];

// these are special character to check whether an email from or reply to name is valid
const INVALID_NAME_CHARACTERS = [","];

const IS_VALID_EMAIL_FROM_NAME = 'isValidFromName';

const IS_VALID_EMAIL_USERNAME = 'isValidUsername';

const IS_VALID_EMAIL_REPLY_TO_NAME = 'isValidReplyToName';

const IS_VALID_DOMAIN = 'isValidDomain';

const INVALID_DOMAIN_MESSAGE = 'Please enter a valid domain.';

const CREATION_VALIDATION_RULES = [
    {
        name: FIELD_EMAIL_NAME,
        validationRules: {
            required: 'Please enter an email name.',
            'min:3': 'Please enter an email name. It must be at least 3 characters long.',
            [`max:${FIELD_EMAIL_NAME_MAX_LENGTH}`]: 'The Email Name can not be more than 150 characters-long!'
        },
    },

    {
        name: FIELD_FROM_NAME,
        validationRules: {
            required: INVALID_NAME_MESSAGE,
            'min:3': 'Please enter a name. It must be at least 3 characters long.',
            [IS_VALID_EMAIL_FROM_NAME]: INVALID_EMAIL_FROM_NAME
        },
    },
    {
        name: FIELD_FROM_EMAIL_USERNAME,
        validationRules: {
            required: REQUIRED_EMAIL_MESSAGE,
            [IS_VALID_EMAIL_USERNAME] : INVALID_EMAIL_USERNAME
        },
    },
    {
        name: FIELD_REPLY_TO_NAME,
        validationRules: {
            required: INVALID_NAME_MESSAGE,
            'min:3': 'Please enter a name. It must be at least 3 characters long.',
            [IS_VALID_EMAIL_REPLY_TO_NAME]: INVALID_EMAIL_REPLY_TO_NAME
        },
    },
    {
        name: FIELD_REPLY_TO_EMAIL_USERNAME,
        validationRules: {
            required: REQUIRED_EMAIL_MESSAGE,
            [IS_VALID_EMAIL_USERNAME]: INVALID_EMAIL_USERNAME
        },
    },
    {
        name: FIELD_REPLY_TO_EMAIL_DOMAIN,
        validationRules: {
            required: INVALID_DOMAIN_MESSAGE,
            [IS_VALID_DOMAIN] : INVALID_DOMAIN_MESSAGE
        }
    },
    {
        name: FIELD_SUBJECT_LINE,
        validationRules: {
            required: 'Please enter a subject line.',
            'min:3': 'Please enter a subject line. It must be at least 3 characters long.',
            [`max:${FIELD_SUBJECT_LINE_MAX_LENGTH}`]: 'The subject line seems too long. Please check the character count and shorten',
        },
    },
    {
        name: FIELD_PREVIEW_TEXT,
        validationRules: {
            [`max:${FIELD_PREVIEW_TEXT_MAX_LENGTH}`]: 'The preview text seems too long. Please check the character count and shorten.'
        }
    },
    {
        name: SEND_TEST_EMAIL,
        validationRules: {
            email: INVALID_EMAIL_MESSAGE,
        },
    },

    {
        name: SCHEDULE_DATE,
        validationRules: {
            required: 'Please enter a schedule date',
        },
    },
    {
        name: SCHEDULE_DATE_HOUR,
        validationRules: {
            required: 'Please enter a schedule hour',
            numeric: 'Schedule hour must be a valid number between 0-23',
            'max_value:23': "Schedule hour can not be greater than 23",
            'min_value:0': "Schedule hour can not be less than 0",
        },
    },

    {
        name: SCHEDULE_DATE_MINUTES,
        validationRules: {
            required: 'Please enter schedule minutes',
            numeric: 'Schedule minutes must be a valid number between 0-59',
            'max_value:59': "Schedule minutes can not be greater than 59",
            'min_value:0': "Schedule minutes can not be less than 0",
        },
    },
];

export { CREATION_VALIDATION_RULES,
        FIELD_EMAIL_NAME, FIELD_FROM_NAME,
        FIELD_FROM_EMAIL_USERNAME, FIELD_REPLY_TO_NAME,
        FIELD_REPLY_TO_EMAIL_USERNAME, FIELD_SUBJECT_LINE, SEND_TEST_EMAIL,
        FIELD_PREVIEW_TEXT,SCHEDULE_DATE, SCHEDULE_DATE_HOUR,
        SCHEDULE_DATE_MINUTES, MISSING_TEMPLATE_ID_MESSAGE,
        FIELD_SUBJECT_LINE_MAX_LENGTH, FIELD_PREVIEW_TEXT_MAX_LENGTH,
        FIELD_EMAIL_NAME_MAX_LENGTH, SELECTED_TIME_BEFORE_NOW,
        INVALID_NAME_CHARACTERS, IS_VALID_EMAIL_FROM_NAME,
        INVALID_SPECIAL_CHARACTERS, IS_VALID_EMAIL_USERNAME,
        INVALID_DOMAIN_MESSAGE, IS_VALID_EMAIL_REPLY_TO_NAME,
        FIELD_REPLY_TO_EMAIL_DOMAIN, IS_VALID_DOMAIN,
        INVALID_EMAIL_FROM_NAME, INVALID_EMAIL_REPLY_TO_NAME, INVALID_EMAIL_USERNAME
};
